module.exports = __webpack_public_path__ + "img/IloiloBacolod2024.036a938f.jpg";